/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, December 2020
 * @format
 * @flow
 */

import React from 'react';
import Container from '../../../../components/Container';
import Body from '../../components/Body';
import styles from './Desktop.module.css';
import Dialog from '../../../../components/Dialog';

export default function Desktop(props) {
  const {
    popup,
  } = props;

  const getPopup = () => {
    if (!popup || popup?.type === 'confirmation') return null;
    return <Dialog {...popup} />;
  };

  return (
    <Container style={styles.container}>
      <Body {...props} />
      {getPopup()}
    </Container>
  );
};
